import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('are_you_sure_you_need_t_pprovalmax_from_scratch'),
    header: defineMessage('some_folks_from_your_or_invite_to_work_together'),
    newAccount: defineMessage('i_need_to_start_from_scratch'),
    joinToExistingAccount: defineMessage('i_will_ask_my_colleagues_for_an_invite'),
};
